export const langsEn: Record<string, unknown> = {
  en: 'English',
  fi: 'Finnish',
  sv: 'Swedish',
  no: 'Norwegian',
  lv: 'Latvia',
  sl: 'Slovenian'
};

export const optionsLanguageEn = [
  {
    label: 'English',
    value: 'en'
  },
  {
    label: 'Finnish',
    value: 'fi'
  },
  {
    label: 'Swedish',
    value: 'sv'
  },
  {
    label: 'Norwegian',
    value: 'no'
  },
  {
    label: 'Latvia',
    value: 'lv'
  },
  {
    label: 'Slovenian',
    value: 'sl'
  }
];

export const langsFi: Record<string, unknown> = {
  en: 'Englanti',
  fi: 'Suomi',
  sv: 'Ruotsi',
  no: 'Norja',
  lv: 'Latviešu',
  sl: 'Sloveeni'
};

export const optionsLanguageFi = [
  {
    label: 'Englanti',
    value: 'en'
  },
  {
    label: 'Suomi',
    value: 'fi'
  },
  {
    label: 'Ruotsi',
    value: 'sv'
  },
  {
    label: 'Norja',
    value: 'no'
  },
  {
    label: 'Latviešu',
    value: 'lv'
  },
  {
    label: 'Sloveeni',
    value: 'sl'
  }
];

export const langsSv: Record<string, unknown> = {
  en: 'Engelska',
  fi: 'Finska',
  sv: 'Svenska',
  no: 'Norska',
  lv: 'Lettland',
  sl: 'Slovenska'
};

export const optionsLanguageSv = [
  {
    label: 'Engelska',
    value: 'en'
  },
  {
    label: 'Finska',
    value: 'fi'
  },
  {
    label: 'Svenska',
    value: 'sv'
  },
  {
    label: 'Norska',
    value: 'no'
  },
  {
    label: 'Lettland',
    value: 'lv'
  },
  {
    label: 'Slovenska',
    value: 'sl'
  }
];

export const langsNo: Record<string, unknown> = {
  en: 'Engelsk',
  fi: 'Finsk',
  sv: 'Svensk',
  no: 'Norsk',
  lv: 'Latviešu',
  sl: 'Slovensk'
};

export const optionsLanguageNo = [
  {
    label: 'Engelsk',
    value: 'en'
  },
  {
    label: 'Finsk',
    value: 'fi'
  },
  {
    label: 'Svensk',
    value: 'sv'
  },
  {
    label: 'Norsk',
    value: 'no'
  },
  {
    label: 'Latviešu',
    value: 'lv'
  },
  {
    label: 'Slovensk',
    value: 'sl'
  }
];

export const langsLv: Record<string, unknown> = {
  en: 'Angļu valoda',
  fi: 'Somu',
  sv: 'Zviedru',
  no: 'Norvēģu',
  lv: 'Latviešu',
  sl: 'Slovēņu'
};

export const optionsLanguageLv = [
  {
    label: 'Angļu valoda',
    value: 'en'
  },
  {
    label: 'Somu',
    value: 'fi'
  },
  {
    label: 'Zviedru',
    value: 'sv'
  },
  {
    label: 'Norvēģu',
    value: 'no'
  },
  {
    label: 'Latviešu',
    value: 'lv'
  },
  {
    label: 'Slovēņu',
    value: 'sl'
  }
];

export const langsSl: Record<string, unknown> = {
  en: 'angleščina',
  fi: 'finščina',
  sv: 'švedščina',
  no: 'norveščina',
  lv: 'latvijščina',
  sl: 'slovenščina'
};

export const optionsLanguageSl = [
  {
    label: 'angleščina',
    value: 'en'
  },
  {
    label: 'finščina',
    value: 'fi'
  },
  {
    label: 'švedščina',
    value: 'sv'
  },
  {
    label: 'norveščina',
    value: 'no'
  },
  {
    label: 'latvijščina',
    value: 'lv'
  },
  {
    label: 'slovenščina',
    value: 'sl'
  }
];
